import {
  faFileArchive,
  faFileAudio,
  faFileCode,
  faFileCsv,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFileVideo,
} from "@fortawesome/free-solid-svg-icons";

/**
 * Format bytes as human-readable text.
 *
 * @param bytes Number of bytes.
 * @param si True to use metric (SI) units, aka powers of 1000. False to use
 *           binary (IEC), aka powers of 1024.
 * @param dp Number of decimal places to display.
 *
 * @return Formatted string.
 */
export const humanFileSize = (
  bytes: number,
  si: boolean = false,
  dp: number = 1
) => {
  const thresh = si ? 1000 : 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  const units = si
    ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  let u = -1;
  const r = 10 ** dp;

  do {
    bytes /= thresh;
    ++u;
  } while (
    Math.round(Math.abs(bytes) * r) / r >= thresh &&
    u < units.length - 1
  );

  return bytes.toFixed(dp) + " " + units[u];
};

export const getFileIcon = (type: string) => {
  if (type.includes("video")) {
    return faFileVideo;
  } else if (type.includes("audio")) {
    return faFileAudio;
  } else if (type.includes("zip")) {
    return faFileArchive;
  } else if (type.includes("pdf")) {
    return faFilePdf;
  } else if (
    type.includes("html") ||
    type.includes("css") ||
    type.includes("json") ||
    type.includes("javascript")
  ) {
    return faFileCode;
  } else if (type.includes("csv")) {
    return faFileCsv;
  } else if (type.includes("sheet")) {
    return faFileExcel;
  }

  return faFileImage;
};

export const getFileName = (name: string) => {
  const [fileName, extension] = name.split(".");
  return `${fileName.slice(0, 24)}.${extension}`.toLowerCase();
};
